import {all, call, put, takeLatest, takeEvery} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import * as actions from '../actions/action_dashboard';

function* dashboardRequested({payload}) {
    try {
        const response = yield call(api.fetchDashboard, payload.id);
        const {startDate, endDate, instanceType} = payload;
        yield put(actions.dashboardSuccess(response.data, startDate, endDate, instanceType));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.dashboardFailure(error));
    }
}

function* exportDashboard({payload}) {
    try {
        const data = yield call(api.exportDashboard, payload.id, payload.params);
        yield put(actions.dashboardExportSuccess(payload.id, data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.dashboardExportFailure(error, payload.id));
    }
}

export default function* root() {
    yield all([
        takeEvery(constants.DASHBOARD_EXPORT_REQUESTED, exportDashboard),
        takeLatest(constants.DASHBOARD_REQUESTED, dashboardRequested),
    ]);
}
